<template><div><h1>vux-loader 介绍</h1>
<p align="left">
  <a href="https://www.npmjs.com/package/vux-loader">
    <img src="https://img.shields.io/npm/v/vux-loader.svg?style=flat-square" alt="">
  </a>
  <a href="https://www.npmjs.com/package/vux-loader">
    <img src="https://img.shields.io/npm/dm/vux-loader.svg?style=flat-square" alt="">
  </a>
</p>
<p><code>vux-loader</code>工具的作用是对<code>.vue</code>代码进行预处理，不限于 vux 组件库。</p>
<p>它是针对<code>webpack+vue-loader</code>项目的工程化工具，简化了webpack插件和loader的使用和编写，支持在vue-loader处理之前进行预处理，同时内置对vux组件专用的配置和优化插件。</p>
<p>当然除了.vue文件外，你还可以对js文件进行预处理。说好的处理.vue文件，为什么连<code>js</code>文件也不放过呢？因为只有处理js才能实现理想工程化。举个例子，如果用户需要在<code>main.js</code>中调用vux的plugin，他需要这样做：</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> AlertPlugin <span class="hljs-keyword">from</span> <span class="hljs-string">'vux/src/plugins/Alert'</span>
<span class="hljs-keyword">import</span> ToastPlugin <span class="hljs-keyword">from</span> <span class="hljs-string">'vux/src/plugins/Toast'</span>
</code></pre>
<p>虽然路径不长，但是看着相当不和谐，为了简化这个操作vux提供了更简洁的写法：</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { AlertPlugin, ToastPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>这个操作即是通过<code>js-parser</code>插件解析main.js里的<code>import</code>语法来实现的，最终进入<code>babel</code>处理的代码和上面单独引入一致。</p>
<p>这个工具也许会帮你进一步打开<code>Vue</code>项目工程化的思路。</p>
<div class="tip">
<p>作为通用工具，即使你没有使用 <code>VUX</code>，依然可以使用它来进行各种代码处理。</p>
</div>
<h2>为什么不使用 babel-plugin-import</h2>
<ul>
<li>VUX 希望使用源码分发</li>
<li>VUX 希望无侵入地解决一系列的工程问题，不需要用户手动配置 webpack</li>
<li>VUX 希望能统计(匿名)使用情况</li>
</ul>
<p>而上面这些单纯使用 <code>babel-plugin-import</code> 无法做到，所以造了个轮子。</p>
</div></template><script>
export default {
  head: {"title":"vux-loader 介绍 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// about-311.vue?84b139a8